import React from "react";
import { useLocation } from "react-router-dom";
import {
  scheduleLenisScrollbarSync,
  useLenis,
  useLenisSyncRef,
} from "./lenisContext";
import { isSettingsV2Path } from "../../universal/v2Routes";

function getScrollResetKey(pathname) {
  if (isSettingsV2Path(pathname)) {
    return "/settings";
  }

  return pathname;
}

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const scrollResetKey = getScrollResetKey(pathname);
  const lenis = useLenis();
  const syncRef = useLenisSyncRef();

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo({ top: 0, left: 0 });
    }

    return scheduleLenisScrollbarSync(syncRef);
  }, [scrollResetKey, lenis, syncRef]);

  return null;
}
